

















import { Component, Vue, Watch, Prop } from "vue-property-decorator";

import ModalTabs from "./ModalTabs.vue";
import FormField from "./FormField.vue";
import EspressoAux from '../../../components/Espresso/EspressoAux.vue';
import { CrudModel } from "@/models/crud";

export class ModalTab {
	icon: string;
	name: string;
	slot?: string; // for custom tabs
	fields: { // for automatic tabs
		key: string,
		class: string;
		style: string;
		props: any;
	}[];
}

@Component({
	components: { ModalTabs, FormField },
})
export default class EntityModal extends Vue {
	@Prop({ required: true })
	private entityModel: CrudModel;

	@Prop({ required: true })
	private id: any;

	@Prop({ required: true })
	private tabs: ModalTab[];

	@Prop({ default: () => [] })
	private joinKeys: string[];

	@Prop()
	private beforePersist?: (entity: any) => void | Promise<void>;

	schema: any = [];
	entity: any = {};
	serverEntity: any = {};
	loading = false;
	error = "";

	private async mounted() {
		this.loading = true;
		try {
			this.schema = await this.entityModel.getDescription();
			await this.readEntity(this.id);
		} catch (error) {
			console.error(error);
		}
		this.loading = false;
	}

	updateNotes(notes: string) {
		this.entity.auditNotes = notes;
	}

	private async readEntity(id: number) {
		this.entity = await this.entityModel.read(id);
		for (let joinKey of this.joinKeys) {
			const joinedEntity = await this.entityModel.read(id, joinKey);
			this.entity[joinKey] = joinedEntity[joinKey];
		}
		this.serverEntity = Object.assign({}, this.entity); // copy entity to compare before update
	}

	private async updateEntity() {
		try {
			if (this.beforePersist) {
				await this.beforePersist(this.entity);
			}
			await this.entityModel.update(this.entity.id, this.entity);
			await this.readEntity(this.entity.id);
			this.$toasted.success('Registro atualizado');
			(this.$refs.entityModalTabs as ModalTabs).clearNotes();
		} catch (error) {
			console.error(error);
			this.$toasted.error(error.friendlyMessage || 'Não foi possível atualizar. Tente novamente.');
		}
		(this.$refs.entityModalTabs as ModalTabs).actionCompleted();
	}

	private async deleteEntity() {
		if (this.schema.find((field: any) => field.key === 'deletionReason') && !this.entity.deletionReason) {
			this.$toasted.error('Selecione uma justificativa para exclusão');
			(this.$refs.entityModalTabs as ModalTabs).actionCompleted();
			return;
		}

		try {
			await this.entityModel.delete(this.entity.id, `Justificativa: ${this.entity.deletionReason} \n${this.entity.auditNotes || ''}`);
			this.$toasted.success('Registro excluído');
			this.$emit('close');
		} catch (error) {
			this.$toasted.error('Não foi possível excluir. Tente novamente.');
		}
		(this.$refs.entityModalTabs as ModalTabs).actionCompleted();
	}

	get enableAction() {
		return JSON.stringify(Object.assign({}, this.entity)) !== JSON.stringify(this.serverEntity);
	}
}
